import { render, staticRenderFns } from "./DomainProgressReviewTable.vue?vue&type=template&id=1b104cc7&scoped=true"
import script from "./DomainProgressReviewTable.vue?vue&type=script&lang=js"
export * from "./DomainProgressReviewTable.vue?vue&type=script&lang=js"
import style0 from "./DomainProgressReviewTable.vue?vue&type=style&index=0&id=1b104cc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b104cc7",
  null
  
)

export default component.exports